export default __webpack_public_path__ + "static/media/logo_refaccionaria.7f987be4.png";